exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1HURd0dKY3RgKpR8pVkL6f{transition:all 0.25s ease}._1HURd0dKY3RgKpR8pVkL6f *{color:#fa6400;display:flex;align-items:center;justify-content:center}._1HURd0dKY3RgKpR8pVkL6f:hover *{color:#fff}\n", ""]);

// Exports
exports.locals = {
	"HeartButton": "_1HURd0dKY3RgKpR8pVkL6f"
};